import React from "react";
import { Link } from 'react-router-dom'

const BtnDelete = ({ href = '', search = '', click='' }) => (
    <div>
        <div className="admin-btndelete">
            <Link to={{ pathname: href, search}} className="action-delete" onClick={click}>ลบ</Link>
        </div>
    </div>
)

export { BtnDelete }